<template>
   <transition name="modal-fade">
      <form class="search-area filterForm" v-on:submit.prevent="onSubmit" >
         <div class="mt-5" v-if="$props.where === 'intro'">
            <div >
               <div class="input-group">
                  <label for="field-area-cerca" class="sr-only d-none active" style="transition: none 0s ease 0s;">Cerca</label>

                  <input type="search" id="field-cerca" placeholder="Cerca" class="form-control" @keyup.prevent="search" v-model="keywords" debounce="500"/>

                  <div class="input-group-append reset">
                     <button class="btn no-radius btn-minimal-padding" type="reset" name="resetModal">
                        <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-close-big"></use></svg>
                     </button>
                  </div>
                     <button class="btn btn-primary btn-minimal-padding" @click="search" name="cercaModal">
                        <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-search"></use></svg>
                     </button>
               </div>
            </div>
            <div class="mt-5">
               <button type="button" class="btn btn-default btn-sm" @click="toggleModal" name="AggiungiFiltriModal">Aggiungi Filtro</button>
            </div>
            <div class="mt-2">
               <b-form-checkbox-group id="checkbox-argomenti-generic" v-model="argomento" :options="this.$root.argomenti" text-field="key" value-field="key" size="sm" buttons plain button-variant="chip"></b-form-checkbox-group>        
               <b-form-checkbox-group id="checkbox-tipologie-generic" v-model="tipologia" :options="tipologie" name="tipologia" text-field="text" value-field="value" buttons plain button-variant="chip"></b-form-checkbox-group>
               <b-form-checkbox class="sm" checked="1" name="check-button" v-model="period" button button-variant="chip">periodo: {{dal}}-{{al}}</b-form-checkbox>
            </div>
         </div>
         <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': active}"
            tabindex="-1"
            role="dialog"
            >
            <div class="modal-dialog modal-xl m-1 m-md-auto" role="document">
              <div class="modal-content p-0 p-md-4">
                  <div class="modal-header">
                     <div class="w-100 d-block clearfix" id="formSearchGeneric">
                       
                        <h4 class="h2" v-if="$props.where !== 'header'">Cerca {{$props.title}}</h4>
                        <h4 class="h2" v-if="$props.where == 'header'">Cerca</h4>

                        <div class="input-group">
                           <label for="field-cerca" class="sr-only d-none active" style="transition: none 0s ease 0s;">Cerca</label>
                              <input type="search" name="q" id="field-cerca" placeholder="Cerca" class="form-control" v-model="keywords"/>

                              <div class="input-group-append reset">
                                 <button class="btn no-radius btn-minimal-padding" type="reset" name="resetRicerca">
                                    <svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-close-big"></use></svg>
                                 </button>
                              </div>
                           <button class="btn btn-primary btn-minimal-padding" type="submit" name="inviaRicerca"><svg class="icon icon-sm"><use xlink:href="@/assets/img/sprite.svg#it-search"></use></svg></button>
                        </div>
                        
                     </div>

                     <div class="d-block clearfix">
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close" @click="toggleModal" name="chiudiModal">
                           <svg class="icon icon-lg"><use xlink:href="@/assets/img/sprite.svg#it-close"></use></svg>
                        </button>     
                     </div>                                        
                  </div>

                  <div class="modal-body p-0 p-md-4 mt-4" id="filterTabs">
                     <h3 class="modal-title primary-color">Filtri</h3>
                     <b-tabs content-class="tab-pane p-4" nav-wrapper-class="nav-link h5 pb-0 text-uppercase text-center" align="center" justified>
                        <b-tab class="w-100" title="ARGOMENTI" active>
                           <b-form-checkbox-group
                              id="checkbox-argomenti-generic"
                              v-model="argomento"
                              :options="this.$root.argomenti"
                              text-field="key"                              
                              value-field="key" 
                              debounce="500"      
                              plain                 
                              stacked      
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab title="TIPI CONTENUTO" v-if="!this.$props.full">
                           <b-form-checkbox-group
                              id="checkbox-tipologia-generic"
                              v-model="tipologia"
                              :options="tipologie"
                              name="tipologia"
                              text-field="text"                              
                              value-field="value"
                              plain
                              stacked
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab title="AREE SPECIALIZZAZIONE" v-if="!this.$props.full">
                           <b-form-checkbox-group
                              id="checkbox-aree-generic"
                              v-model="areaSpecializzazione"
                              :options="this.$root.areeSpeciali"
                              name="areaSpecializzazione"
                              text-field="titolo"                              
                              value-field="id"
                              plain
                              stacked
                           ></b-form-checkbox-group>
                        </b-tab>

                        <b-tab  title="PERIODO" v-if="this.$props.full">
                           <div class="row">
                              <div class="form-check col-12 col-md-4">
                                 <div class="toggles">
                                    <label for="toggleEsempio1a" class="text-uppercase">
                                    PERIODO
                                    <!--input type="checkbox" id="toggleEsempio1a" data-toggle="collapse" data-target="#dateRange" class="" aria-expanded="true"><span class="lever"></span--></label>
                                 </div>
                                 <p>
                                    Se non indichi un  “Periodo” di riferimento saranno mostrati tutti i contenuti dal più recente al meno recente partendo dalla data odierna
                                 </p>
                              </div>
                              <div class="col-12 col-md-8 collapse show" id="dateRange" style="">
                                 <div class="row">
                                    <div class="col-12 col-md-6">
                                       <div class="it-datepicker-wrapper mt-5">
                                          <div class="form-group">
                                             <label for="dal" class="pl-0 active" style="transition: none 0s ease 0s;">DAL</label>     
                                             <date-picker 
                                                v-model="dal"
                                                placeholder="gg/mm/aaaa"
                                                :name="`date1`"
                                                input-class="form-control it-date-datepicker"
                                                :input-attr="({ name: 'dal', id: 'dal'})"
                                                :disabled-date="notAfterAl"
                                                format="DD/MM/YYYY"
                                                valueType="DD/MM/YYYY"
                                                >                                                
                                             </date-picker>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                       <div class="it-datepicker-wrapper mt-5">
                                          <div class="form-group">               
                                             <label for="al" class="pl-0 active" style="transition: none 0s ease 0s;">AL</label>
                                             <date-picker 
                                                v-model="al" 
                                                placeholder="gg/mm/aaaa" 
                                                :input-attr="({ name: 'al', id: 'al'})"
                                                input-class="form-control it-date-datepicker" 
                                                :disabled-date="notBeforeDal"
                                                format="DD/MM/YYYY"
                                                valueType="DD/MM/YYYY"
                                                >
                                             </date-picker>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </b-tab>
                     </b-tabs>
                     <div class="float-right input-group-inline ml-auto">
                        <button type="submit" class="btn btn-primary ml-auto" id="applyFilterBtn">
                           Applica i filtri
                        </button>
                     </div>                     
                  </div>

               </div>
            </div>
         </div>
         <div v-if="active" class="modal-backdrop fade show"></div>
      </form>
   </transition>
</template>
<script>
   import DatePicker from 'vue2-datepicker';
   import 'vue2-datepicker/index.css';
   import 'vue2-datepicker/locale/it';
   import axios from 'axios';

   export default {
      name: "searchGeneric",

      components: { 
         DatePicker,
      },  

      props: {
         where: {
            type: String,
            description: "Dove di trova la ricerca e il comportamento"
         },
         title:{
            type: String,
            description: "titolo della ricerca"
         },
         full:{
            type: Boolean,
            default: false            
         }               
      },

      data() {
         return {
            active: false,
            show: false,
            dal: '',
            al: '',
            period: false,
            keywords: '',
            filters: [],
            areaSpecializzazione: [],
            areeSpecializzazione: [],            
            argomento: [],
            argomenti: [],
            tipologia: [],
            tipologie: [
               { text: 'Articolo', value: 'ArticoloPublished' },
               { text: 'Evento', value: 'EventoPublished' },
               { text: 'Notizia', value: 'NotiziaPublished' },
               { text: 'Partecipanti', value: 'PartecipantiPublished' },               
            ],        
            pager:{
               currentPage: 1,
               totalResults: 0,
               from: 0,
               limit: 9
            },              
            sortBy:{
               selected: '_score',
               sorting: [
                  { value: "_score", text: 'Rilevanza' },
                  { value: {"data.titolo.iv.keyword": {"order" : "asc"}}, text: 'Titolo A-Z' },
                  { value: {"data.titolo.iv.keyword": {"order" : "desc"}}, text: 'Titolo Z-A' },
                  { value: {"created": {"order" : "desc"}}, text: 'Più recente' },
                  { value: {"created": {"order" : "asc"}}, text: 'Meno recente' },
               ]
            },       
            sort:[{"_score": {"order":"desc"}}],             
         };
      },
      
      mounted(){
         this.argomenti = this.$root.argomenti;
      },

      methods: {
         /**
          * when clicking on button in bootstrap
          * the modal style set to display and after that a show class add to modal
          * so to do that we will show modal-backdrop and set modal display to block
          * then after that we will add show class to the modal and we will use setTimeout
          * to add show class because we want show class to add after the modal-backdrop show and modal display change
          * to make modal animation work
          *
         */
         toggleModal() {
            const body = document.querySelector("body");
            this.active = !this.active;
            this.active
              ? body.classList.add("modal-open")
              : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
         },
         notAfterAl(date) {
            if(this.al !== null){
               return date > new Date(this.al);
            }
            else{
               return date > new Date(new Date().setHours(0, 0, 0, 0));
            }
         },     
         notBeforeDal(date) {
            if(this.dal !== null){
               return date < new Date(this.dal);
            }
            else{
               return date > new Date(new Date().setHours(0, 0, 0, 0));
            }
         },

         onSubmit(){
            this.$router.push({ name: 'Cerca' , 
                                 params: {
                                    keywords : this.keywords,
                                    argomenti: this.argomento,
                                    areeSpecializzazione: this.areaSpecializzazione,
                                    tipologie: this.tipologia
                                 }
                              });             
            this.toggleModal();
         },

         search() {           
            axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
               {
                  "size": this.pager.limit,
                  "from" : this.pager.from,   
                  "track_scores": true,
                  "aggs": {
                   "S3": {
                     "terms": {
                       "field": "data.s3.iv.keyword",
                       "size": 10
                     }
                   },
                   "Aree Specializzazione": {
                     "terms": {
                       "field": "data.areeSpecializzazione.iv.keyword",
                       "size": 10
                     }
                   },
                   "Argomenti": {
                     "terms": {
                       "field": "data.argomenti.iv.keyword",
                       "size" : 40,
                       "order": { "_term": "asc" }
                     }
                   }
                  },
                  "_source": {
                     "excludes": [ "timestamp", "appId", "createdBy", "actor", "version", "partition"]
                  },                    
                  "sort" : this.sort,
                  "query": {
                     "simple_query_string": {
                        "query": this.query+'*',
                        "flags": "ALL",
                        "fuzzy_transpositions": true,
                        "fuzzy_max_expansions": 50,
                        "fuzzy_prefix_length": 0,
                        "minimum_should_match": 0,
                        "default_operator": "or",
                        "lenient": true,
                        "analyzer": "standard",
                        "quote_field_suffix": "",
                        "analyze_wildcard": false,
                        "auto_generate_synonyms_phrase_query": true,
                     }                                   
                  }  
               },
               {
                  auth: { 
                     username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
                     password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
                  }
               }
            ).then(response => {
               //this.$emit('searched', response.data.hits)               
               this.data = response.data.hits;
               this.facets = response.data.aggregations;
               this.pager.totalResults = response.data.hits.total.value;
            })
         },

         changeSorting(event) {
            if(event == '_score'){
               this.sort = [{"_score": {"order":"desc"}}];
            }
            else{         
               this.sort = event;
            }
            this.search();
         },

         changePage(value){
            this.pager.from = this.pager.limit * (value - 1);
            this.pager.currentPage = value;         
            this.search();
         },

         setLimit(value){
            this.pager.limit = value;
            this.search();
         }         
      }
   };

</script>
<style>
#filterTabs .nav-item .nav-link{ width:100%; }
input[type="search"]:placeholder-shown + .input-group-append > .reset {
    display: none;
}
.close{position:absolute;right: 40px;top: 30px;}
input[type="checkbox"]{margin-right: 0.5rem;}
.input-group-append .btn[type="reset"]{position:unset;}
.btn-group{ display:inline-block; }
.btn.btn-chip:hover:not(.chip-disabled) {
   background: #F2F2F2;
   border-color: #005c99;
   transition: background-color 0.1s;
   text-decoration: none;
   font-weight: 600;
}

.btn.btn-chip {
   margin-bottom: 6px;
   display: none;
   justify-content: space-evenly;
   align-items: center;
   background: #fff;
   border: 1px solid #005c99;
   border-radius: 12px !important;
   color: #000;
   height: 24px;
   min-width: 100px;
   padding: 4px 32px 4px 32px !important;
   transition: all 0.05s;
   margin-right: 4px;
   font-size: 0.77778rem;
   text-decoration: none;
   font-weight: 600;
   line-height: 1.0rem;
   height: min-content;
   white-space: nowrap;
   box-shadow: unset !important;
}
    
.btn.btn-chip > span {
   font-size: 0.778rem;
   height: 16px;
   font-weight: 600;
   color: #000 !important;
   margin-bottom: 0;
   transform: translateY(-2px);
   transition: color 0.05s;
   text-decoration: none;    
   margin-left: -6px;
 }

.btn.btn-chip > span:after{
   content: "x";
   position: relative;
   right: -6px;
   top: -1px;
   font-weight: normal;
   color: #666;
   transform:scale(1.25, 1.1);
   cursor: pointer;
 }
.btn.btn-chip.active {
   display: inline-block;
}
</style>
